module.exports = __webpack_public_path__ + "img/LUCKYBLOCK.104d4a5d.svg";